import React from "react"
import styles from "./teleworkjoinus.css"

const TeleworkJoinus = (props) => {

  return (
    <section className="join" id="Joinus">
      
      <div className="joinuswrap">
      <div className="containfix">
        <div className="joinus">
          <div className="jtext">
            JOIN US!
          </div>
          <div className="colcenter"></div>
          <div className="regcol">
            <a className="regop" href="https://event.on24.com/wcc/r/2495071/4C8A5A4B56A70EFB0066412DE62E6CC1" target="_blank">REGISTER »</a>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default TeleworkJoinus